export enum TransportDocumentType {
  PICTURE = 'PICTURE', APP_DOCUMENT = 'APP_DOCUMENT'
}


export class DocumentPreview {

  type: TransportDocumentType;

  title: string;

  titleDictionaryKey: string;

  subTitle: string;

  identifier: string;

  source: string;

  /*
   * Link to the preview resource.
   */
  previewResourceUUID: string;

  mimeType: string;

  deletedInTime: boolean;

  publishedInTime: boolean;

}
